import { getControllerApiVersion, isZonable } from './utils';
import { supportsCo2SettingsRelocation } from './co2_utils';

export const getAdvertisedCirculationCount = (controller, parent) => {
  const count = controller?.multi_io_counters?.circulation_count ??
    parent?.multi_io_counters?.circulation_count ??
    parent?.settings?.multi_io?.circulation_count ??
    controller?.settings?.multi_io?.circulation_count;
  return Number.isInteger(count) && count >= 0 && count <= 255 ? count : undefined;
};

export const getCirculationCount = (controller, parent) => {
  const version = getControllerApiVersion(controller);
  // Pro circulation settings are not implemented yet; keep legacy index zero.
  if (controller?.type === 6000) return 1;
  if (!version) return 0;
  if (!isZonable(controller) || version < 'BAIC') return 1;
  return Math.min(getAdvertisedCirculationCount(controller, parent) ?? 0, 4);
};

export function supportsCirculationSettings(controller, parent) {
  // Define Pro's independent native version gate when its implementation lands.
  return controller?.type === 5155 &&
    getControllerApiVersion(controller) >= 'BAIC' &&
    parent?.settings?.ventilation?.has_circulation === true &&
    Array.isArray(parent?.settings?.ventilation?.circulation) &&
    parent.settings.ventilation.circulation.length === 4;
}

// Exchange remains editable on older controllers, including restored drafts
// containing circulation fields from a previously connected firmware.
export function supportedVentilationSettings(controller, parent, settings) {
  const result = { ...settings };
  if (!supportsCirculationSettings(controller, parent)) {
    delete result.circulation;
    delete result.has_circulation;
  } else {
    result.has_circulation = true;
  }
  if (!supportsCo2SettingsRelocation(controller)) delete result.pressure_percent_co2;
  return result;
}
